<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2016</p>
<div class="timebreak "> </div>
<p class="center ">Copyright © 2016 by Jonathan Moore</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center "><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Moore, Jonathan, date.</p>
<p class="center ">The poison artist / Jonathan Moore.</p>
<p class="center ">pages cm</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-544-52056-1 (hardback)—<span class="smallcaps">ISBN</span> 978-0-544-54643-1 (ebook)—<span class="smallcaps">ISBN</span> 978-0-544-81182-9 (pbk.)</p>
<p class="center ">I. Title.</p>
<p class="center ">PS3613.O56275P75 2016</p>
<p class="center ">813'.6—dc23</p>
<p class="center ">2015004343</p>
<div class="timebreak "> </div>
<p class="center ">Cover design by Mark R. Robinson<br/>
Cover photographs: © Jay Walsh (house), © Dawn D. Hanna / Getty Images (shadow)</p>
<div class="timebreak "> </div>
<p class="center ">v2.1116</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?13561c8c